// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609250849/js/" + chunkId + "." + {"44":"3cacf0d4","225":"4373c6f0","481":"0430c7cb","486":"a27bd953","770":"15fe646c"}[chunkId] + ".0.7903913879961809.chunk.js";
};